import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconBusinessCandidateFill from './icon-business-candidate-fill.vue';

const IconBusinessCandidateFill = Object.assign(_IconBusinessCandidateFill, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconBusinessCandidateFill.name, _IconBusinessCandidateFill);
  }
});

export default IconBusinessCandidateFill;
